export default __webpack_public_path__ + "static/media/CaloriesBurnt.7cbdd833.svg";